import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=0528328d&"
import script from "./Statistics.ts?vue&type=script&lang=ts&"
export * from "./Statistics.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports